import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { useAxios } from '../context/AxiosContext';

export function useTemplates(search: string) {
  const { authAxios } = useAxios();

  const fetchTemplateNames = useCallback(
    async (templateName) => {
      if (templateName.length < 3) return;
      const response = await authAxios.get<any>('/reseller/templates', {
        params: {
          term: templateName
        }
      });
      return response.data;
    },
    [authAxios]
  );

  return useQuery(['reseller-jobs', search], () => fetchTemplateNames(search));
}
